export class LocalStorageKeys {
  static TABLE_COLUMNS = 'TABLE_COLUMNS'
  static TABLE_CUSTOMIZATION_BADGE = 'TABLE_CUSTOMIZATION_BADGE'
}
